export const PHOTO_QUESTION_IDS: ReadonlyArray<string> = [
  'TakeInstantCheckup',
  'TakeInstantCheckSideFace',
  'HairfallPhoto',
  'HairfallPhotoTop',
  'followUpTakeInstantCheckupFrontFace',
  'followUpTakeInstantCheckupFrontFace2',
  'followUpTakeInstantCheckupSideFace',
];

export function isPhotoQuestion(
  chat: Parse.Object | null | undefined,
  className: string | undefined,
): boolean {
  if (className !== 'ConsultationSession' && className !== 'FollowUp') return false;
  return PHOTO_QUESTION_IDS.includes(chat?.get('questionId'));
}
